import template from './account.html';
import './account.global.css';

export default function AccountComponent() {
  return {
    scope: {},
    template,
  };
}
